import React, { createContext, useContext, useState, useEffect } from "react";
import { useVerifySessionQuery, useLogoutMutation } from "../store/apiSlice";
// import { setHourlyCookie } from "../utils/cookies";
import { useStoreInfo } from "./StoreInfoContext";
import { clearCart } from "../utils/cart";
import { deleteCookie } from "../utils/cookies";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { customerId, storeId } = useStoreInfo();
  const [logoutMutation] = useLogoutMutation();

  // Verify session with backend if user exists
  const {
    data: sessionData,
    isLoading: sessionLoading,
    error: sessionError,
  } = useVerifySessionQuery({ customerId, storeId });

  useEffect(() => {
    if (!sessionLoading) {
      if (sessionError) {
        // Session is invalid, clear user data
        console.error("Session verification failed:", sessionError);
        setUser(null);
      } else if (sessionData.result?.user) {
        setUser(sessionData.result.user);
        // setHourlyCookie(
        //   "swagstore_user",
        //   JSON.stringify(sessionData.result.user)
        // );
      }
      setLoading(false);
    }
  }, [sessionData, sessionLoading, sessionError]);

  const login = (userData, token = null) => {
    setUser(userData);
    // setHourlyCookie("swagstore_user", JSON.stringify(userData));
    if (token) {
      // setHourlyCookie("swagstore_user_token", token);
    }
  };

  const logout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch (error) {
      console.error("Logout API error:", error);
    }

    const cookieNames = [
      "auth_token",
      "authToken",
      "swagstore_user_token",
      "swagstore_user",
      "storeSelection",
    ];

    cookieNames.forEach((name) => {
      deleteCookie(name);
    });

    setUser(null);
    clearCart();
  };

  const updateUser = (updatedData) => {
    const newUserData = { ...user, ...updatedData };
    setUser(newUserData);
    // setHourlyCookie("swagstore_user", JSON.stringify(newUserData));
  };

  const value = {
    user,
    login,
    logout,
    updateUser,
    loading,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
